import React from 'react';
import {
  AuthTemplateCentralizedContainer,
  AuthTemplateLogo,
} from '@identity/components';
import { Gap, Gutter, Text, Title } from '@common/components';
import { useParams } from '@common/hooks';

export function SignInFailurePage() {
  const { error } = useParams<{ error: string }>();
  const errorCode = decodeURIComponent(error);

  return (
    <AuthTemplateCentralizedContainer>
      <AuthTemplateLogo />
      <Gutter internal size="xxl" />
      <Gap vertical>
        <Title size="h3" weight="medium">
          {handleErrorMessage(errorCode)}
        </Title>
        <Text size="lg">
          Please try again or contact our Works Specialist at{' '}
          <a href="mailto:support@workshealth.com">support@workshealth.com</a>
        </Text>
        <Text>Error: {errorCode}</Text>
      </Gap>
    </AuthTemplateCentralizedContainer>
  );
}

function handleErrorMessage(errorCode: string) {
  if (errorCode === 'access_denied') {
    return 'You are not authorized to access Works yet.';
  }

  return 'There was a problem authenticating you.';
}
